export const COLORS = {
  bgPrimary: 'rgb(60, 60, 60)',
  headerBlue: '#0096d6',
  offWhite: ' rgb(244, 244, 244)',
  blueShade2: 'rgba(0, 150, 214, 0.1)',
  bgWhite: '#ffffff',

  // text colors
  textSecondary: 'rgb(74, 74, 74)',
  textPrimary: 'rgb(60, 60, 60)',
  $textWhite: '#ffffff',

  // border colors
  brLightGrey: 'rgb(155, 155, 155)',
  brVeryLightGray: '#dadada',

  // shadow
  sdLightGrey: '#cdcdcd',
  sdVeryLightGrey: '#e7e7e7',

  themeBlue: '#0096d6'
};
